import { render, staticRenderFns } from "./EditLeadDetailsDialog.vue?vue&type=template&id=51536888&scoped=true"
import script from "./EditLeadDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./EditLeadDetailsDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditLeadDetailsDialog.vue?vue&type=style&index=0&id=51536888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51536888",
  null
  
)

export default component.exports